let googleMap = null;

const getPosition = function(options) {
  return new Promise(function(resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
};

const locations = [
  {
    lat: -31.56391,
    lng: 147.154312,
    title: 'Altona Meadows',
    description: `   Phone:  Fax: `,
    street: '330 Queen Street',
    city: 'Altona Meadows',
    code: '3028',
    phone: '8368 3000',
    fax: '9360 7534',
    childOnly: true,
    adultsHelp: false,
    destination: 'ipc-health-altona-meadows'
  },
  {
    lat: -33.718234,
    lng: 150.363181,
    title: 'Ararat',
    description: 'Girdlestone Street Ararat 3377 Phone: 5352 9327 Fax: 5352 9319',
    street: 'Girdlestone Street',
    city: 'Ararat',
    code: '3377',
    phone: '5352 9327',
    fax: '5352 9319',
    childOnly: false,
    adultsHelp: true,
    destination: 'east-grampians-health-service2'
  },
  {
    lat: -33.727111,
    lng: 150.371124,
    title: 'Ashburton',
    description: '7 Samarinda Avenue Ashburton 3147 Phone: 9885 6822 Fax: 9885 6844',
    street: '7 Samarinda Avenue',
    city: 'Ashburton',
    code: '3147',
    phone: '9885 6822',
    fax: '9885 6844',
    childOnly: false,
    adultsHelp: true,
    destination: 'access-health-and-community'
  },
  {
    lat: -33.848588,
    lng: 151.209834,
    title: 'Bairnsdale',
    description: 'lRoss Street Bairnsdale 3875 Phone: 5152 0278 Fax: 5152 4464',
    street: 'Ross Street',
    city: 'Bairnsdale',
    code: '3875',
    phone: '5152 0278',
    fax: '5152 4464',
    childOnly: false,
    adultsHelp: true,
    destination: 'bairnsdale-regional-health-service'
  },
  {
    lat: -33.851702,
    lng: 151.216968,
    title: 'Bell Park',
    description: 'l62 Morgan St Bell Park 3215 Phone: 5277 2038 Fax: 5277 3537',
    street: '62 Morgan St',
    city: 'Bell Park',
    code: '3215',
    phone: '5277 2038',
    fax: '55277 3537',
    childOnly: true,
    adultsHelp: false,
    destination: 'barwon-health-wathaurong-aboriginal-cooperative2'
  }
];

class GoogleMap {
  constructor({ id, locationsObj, position }) {
    this.mapContainer = document.getElementById(id);
    this.locationsObj = locationsObj;
    this.map = null;
    this.markerClusterer = null;
    this.markersArray = [];
    this.labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    this.infoWin = new google.maps.InfoWindow();
    this.marker = null;
    this.position = position;

    this._initMap();
    this._initMarkers();
  }

  _initMap() {
    const { latitude, longitude } = this.position.coords;

    this.map = new google.maps.Map(this.mapContainer, {
      zoom: 3,
      center: { lat: latitude, lng: longitude }
    });

    const marker = new google.maps.Marker({ position: { lat: latitude, lng: longitude }, map: this.map });
  }

  addMarker(location) {
    const { lat, lng, title, street, city, code, phone, fax } = location;
    this.marker ? this.marker.setMap(null) : null;
    this.marker = new google.maps.Marker({ position: { lat, lng }, map: this.map });

    if (title || street || city || code || phone || fax) {
      this.infoWin ? this.infoWin.close(map, this.marker) : null;

      const titleTemplate = title && `<h3 class='marker__title'>${title}</h3>`;
      const streetTemplate = street && `<div>${street}</div>`;
      const cityTemplate = city && `<div>${city}</div>`;
      const codeTemplate = code && `<div>${code}</div><br />`;
      const phoneTemplate = phone && `<div>Phone: ${phone}</div>`;
      const faxTemplate = fax && `<div>Fax: ${fax}</div>`;

      const template = () => titleTemplate + streetTemplate + cityTemplate + codeTemplate + phoneTemplate + faxTemplate;

      this.infoWin.setContent(template());
      this.infoWin.open(this.map, this.marker);
    }
  }

  _initMarkers() {
    this.locationsObj.map((location, i) => {
      const { lat, lng, title, street, city, code, phone, fax } = location;
      this.markersArray.push(
        new google.maps.Marker({
          position: { lat, lng },
          label: this.labels[i % this.labels.length]
        })
      );
      // this.infoWin = new google.maps.InfoWindow();
      google.maps.event.addListener(this.markersArray[i], 'click', () => {
        const titleTemplate = title && `<h3 class='marker__title'>${title}</h3>`;
        const streetTemplate = street && `<div>${street}</div>`;
        const cityTemplate = city && `<div>${city}</div>`;
        const codeTemplate = code && `<div>${code}</div><br />`;
        const phoneTemplate = phone && `<div>Phone: ${phone}</div>`;
        const faxTemplate = fax && `<div>Fax: ${fax}</div>`;

        const template = () => titleTemplate + streetTemplate + cityTemplate + codeTemplate + phoneTemplate + faxTemplate;

        this.infoWin.setContent(template());
        this.infoWin.open(this.map, this.markersArray[i]);
      });
    });
    this.markerClusterer = new MarkerClusterer(this.map, this.markersArray, {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    });
  }

  _clearOverlays() {
    for (var i = 0; i < this.markersArray.length; i++) {
      this.markersArray[i].setMap(null);
    }
    this.markersArray.length = 0;
    this.markerClusterer.clearMarkers();
  }

  addMarkers(locationsObj) {
    this._clearOverlays();
    locationsObj.map((location, i) => {
      this.markersArray.push(
        new google.maps.Marker({
          position: location,
          label: this.labels[i % this.labels.length]
        })
      );
    });
    this.markerClusterer = new MarkerClusterer(this.map, this.markersArray, {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    });
  }
}

// const googleMap = new GoogleMap({ id: 'map', locationsObj: locations });

class SearchList {
  constructor({ listSelector, searchSelector, locationsObject, childOnlyId, adultsHelpId }) {
    this.list = document.querySelector(listSelector);
    this.search = document.querySelector(searchSelector);
    this.locations = locationsObject;
    this.returnedLocations = locationsObject;
    this.elements = [];
    this.childOnly = document.getElementById(childOnlyId);
    this.adultsHelp = document.getElementById(adultsHelpId);

    this._init();
  }

  _init() {
    this._createList();
    this._searchList();
  }

  _createList() {
    this.locations.map(location => {
      const locationLi = this._createElement(
        'li',
        null,
        ['map-locations__item', 'hidden'],
        [
          {
            attrType: 'data-location',
            attr: `${location.lat}, ${location.lng}`
          },
          {
            attrType: 'data-child',
            attr: location.childOnly
          },
          {
            attrType: 'data-adults',
            attr: location.adultsHelp
          }
        ]
      );

      const { street, city, code, phone, fax } = location;

      const streetTemplate = street && `<div>${street}</div>`;
      const cityTemplate = city && `<div>${city}</div>`;
      const codeTemplate = code && `<div>${code}</div><br />`;
      const phoneTemplate = phone && `<div>Phone: ${phone}</div>`;
      const faxTemplate = fax && `<div>Fax: ${fax}</div>`;

      const template = () => streetTemplate + cityTemplate + codeTemplate + phoneTemplate + faxTemplate;

      const locationLink = this._createElement('a', null, ['map-locations__link'], [{ attrType: 'href', attr: '#' }]);
      const locationTitle = this._createElement('h3', location.title, ['map-locations__title'], null);
      const locationDescritpion = this._createElement('div', template(), ['map-locations__description'], null);

      locationLink.appendChild(locationTitle);
      locationLink.appendChild(locationDescritpion);
      locationLink.addEventListener('click', e => {
        e.preventDefault();
        googleMap.addMarker(location);
      });
      locationLi.appendChild(locationLink);
      this.elements.push(locationLi);
      this.list.appendChild(locationLi);
    });
  }

  _createElement(elementType, elementContent, elementClasses, attributes) {
    const element = document.createElement(elementType);
    element.classList.add(...elementClasses);
    if (attributes) {
      attributes.map(attribute => {
        element.setAttribute(attribute.attrType, attribute.attr);
      });
    }
    if (elementContent) {
      element.innerHTML = elementContent;
    }

    return element;
  }

  _searchList() {
    this.search.addEventListener('input', event => {
      this._checkList(event.target.value);
    });

    this.childOnly.addEventListener('click', () => {
      if (this.search.value) {
        this._checkList(this.search.value);
      }
    });

    this.adultsHelp.addEventListener('click', () => {
      if (this.search.value) {
        this._checkList(this.search.value);
      }
    });
  }

  _checkList(value) {
    this.returnedLocations = [];

    [...this.elements].map((item, index) => {
      if (item.innerText.toUpperCase().includes(value.toUpperCase())) {
        if (item.getAttribute('data-child') === this.childOnly.checked.toString()) {
          item.classList.remove('hidden');
          this.returnedLocations.push(this.locations[index]);
        } else if (item.getAttribute('data-adults') === this.adultsHelp.checked.toString()) {
          item.classList.remove('hidden');
          this.returnedLocations.push(this.locations[index]);
        } else {
          item.classList.add('hidden');
        }
      } else {
        item.classList.add('hidden');
      }
    });
    if (this.returnedLocations.length > 0) {
      googleMap.addMarkers(this.returnedLocations);
    }
  }
}

class SelectLocations {
  constructor({ selector: selector, locationsObj: locationsObj }) {
    this.select = document.querySelector(selector);
    this.locations = locationsObj;

    this._init();
  }

  _init() {
    this.locations.map(location => this._createOptions(location));
    this.select.addEventListener('change', () => {
      window.location = this.select.options[this.select.selectedIndex].getAttribute('data-destination');
    });
  }

  _createOptions({ title, destination }) {
    const option = document.createElement('option');
    option.setAttribute('value', title);
    option.setAttribute('data-destination', destination);
    option.innerHTML = title;

    this.select.appendChild(option);
  }
}

const checkMap = document.getElementById('map');

if (checkMap) {
  getPosition()
    .then(position => {
      googleMap = new GoogleMap({ id: 'map', locationsObj: locations, position });
    })
    .catch(err => {
      console.error(err.message);
    });

  const locList = new SearchList({
    listSelector: '.map-locations__list',
    searchSelector: '.map-filters__name',
    locationsObject: locations,
    childOnlyId: 'child',
    adultsHelpId: 'adults'
  });

  const locationsSelect = new SelectLocations({ selector: '.map-filters__location', locationsObj: locations });
}
